import { apiFetch } from "./client";

/**
 * Validate a coupon code for eligibility against a cart total.
 * @param {Object} params
 * @param {string} params.code
 * @param {number} params.cartTotal
 * @param {string} [params.userId]
 * @returns {Promise<{ isValid: boolean, message: string, couponId: string, code: string, couponType: number, amount: number, discountAmount: number, finalTotal: number }>}
 */
export function validateCoupon({ code, cartTotal, userId }) {
  return apiFetch("/api/coupon/validate", {
    method: "POST",
    body: JSON.stringify({
      code: code?.trim(),
      cartTotal: Number(cartTotal) || 0,
      userId: userId || undefined,
    }),
  });
}
